import {Theme} from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function DataGrid(theme: Theme) {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          border: `1px solid transparent`,
          direction: 'rtl',
          '& .MuiTablePagination-root': {
            borderTop: 0
          },
          '& .MuiDataGrid-toolbarContainer': {
            padding: theme.spacing(2),
            backgroundColor: theme.palette.background.neutral,
            '& .MuiButton-text': {
              marginInlineEnd: theme.spacing(1.5),
              color: theme.palette.text.primary,
              '&:hover': {
                backgroundColor: theme.palette.action.hover
              }
            }
          },
          '& .MuiDataGrid-main': {direction: 'rtl'},
          '& .MuiDataGrid-virtualScroller': {direction: 'rtl'},
          '& .MuiDataGrid-scrollbar': {
            insetInlineStart: 0,
            insetInlineEnd: 'unset'
          },
          '& .MuiDataGrid-cell, .MuiDataGrid-columnsContainer': {
            borderBottom: `1px solid ${theme.palette.divider}`
          },
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          },
          '& .MuiDataGrid-columnSeparator': {
            color: theme.palette.divider
          },
          '& .MuiDataGrid-columnHeader': {
            justifyContent: 'center',
            '&[data-field="__check__"]': {
              padding: 0
            },
            '&:focus, &:focus-within': {
              outline: 'none'
            }
          },
          '& .MuiDataGrid-columnHeaderTitleContainer': {
            justifyContent: 'center'
          },
          '& .MuiDataGrid-columnHeaderTitleContainerContent': {
            justifyContent: 'center',
            width: '100%'
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            textAlign: 'center',
            width: '100%',
            fontWeight: 600
          },
          '& .MuiDataGrid-colCellTitle': {textAlign: 'center'}
        },
        // MUI X v7 exposes panel sub-components via slot keys on MuiDataGrid,
        // NOT as separate MuiGrid* component names. The previous
        // MuiGridMenu/MuiGridFilterForm/MuiGridPanelFooter blocks were dead
        // code (those component names are not registered in v7).
        menu: {
          '& .MuiDataGrid-gridMenuList': {
            boxShadow: theme.customShadows.z20,
            borderRadius: theme.shape.borderRadius
          },
          '& .MuiMenuItem-root': {
            ...theme.typography.body2
          }
        },
        filterForm: {
          // MUI X v7 GridFilterForm is a flex row whose direct children are
          // bare <div> slot wrappers (filterFormColumnInput / OperatorInput /
          // ValueInput, etc.) with fixed widths and NO horizontal spacing
          // between them, so columns/operator/value end up flush. MUI's
          // built-in margins on LogicOperatorInput/DeleteIcon use physical
          // `marginRight`, which stylis-plugin-rtl flips to the wrong side.
          // Use `gap` on the flex row + logical margin resets on the two
          // slots that ship with physical margins.
          padding: theme.spacing(1.5, 1),
          gap: theme.spacing(1.5),
          alignItems: 'flex-end',
          '& .MuiDataGrid-filterFormLogicOperatorInput': {
            marginRight: 0,
            marginInlineEnd: 0
          },
          '& .MuiDataGrid-filterFormDeleteIcon': {
            marginRight: 0,
            marginInlineEnd: 0,
            marginBottom: 0,
            alignSelf: 'center'
          },
          '& .MuiFormControl-root': {
            margin: 0
          },
          '& .MuiInput-root': {
            marginTop: theme.spacing(3),
            '&::before, &::after': {
              display: 'none'
            },
            '& .MuiNativeSelect-select, .MuiInput-input': {
              ...theme.typography.body2,
              padding: theme.spacing(0.75, 1),
              borderRadius: theme.shape.borderRadius,
              backgroundColor: theme.palette.background.neutral
            },
            '& .MuiSvgIcon-root': {
              insetInlineEnd: 4
            }
          }
        },
        panelFooter: {
          padding: theme.spacing(1.5, 2),
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          // Explicit gap so the two action buttons (+הוסף מסנן / מחק הכל)
          // never collapse together regardless of how the filter panel
          // distributes them. justifyContent: space-between alone is not
          // enough when only one button is present or when wrapping kicks in.
          gap: theme.spacing(2),
          '& .MuiButton-root': {
            marginInlineStart: 0,
            marginInlineEnd: 0
          }
        }
      }
    }
  }
}
